function handleSwatches() {
  const variantSwatches = document.querySelectorAll('.variant-swatch');
  const collectionSwatch = window.theme.strings.collectionSwatch;
  const variantSwatchSet = new Set();
  const swatchFilters = document.querySelector('.filter-swatch');

  if (!variantSwatches.length || !collectionSwatch) return; 

  variantSwatches.forEach((swatch) => {
    const swatchValue = swatch.getAttribute('title');
    variantSwatchSet.add(swatchValue);
  });

  if ([...variantSwatchSet].some(swatch => swatch.includes(collectionSwatch))) {
    variantSwatches.forEach((swatch) => {
      const swatchValue = swatch.getAttribute('title');
      const swatchVariantLink = swatch.getAttribute('href');
      
      if (!swatchValue.includes(collectionSwatch)) {
        swatch.style.display = 'none';
        swatchFilters.style.display = 'none';
      } else {
        const swatchParentCard = swatch.closest('product-card');

        if (swatchParentCard) {
          const cardLinks = swatchParentCard.querySelectorAll('a');
          cardLinks.forEach((link) => {
            link.setAttribute('href', swatchVariantLink);
          });
        }
      }
    });
  }
}

handleSwatches();